'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _resource = require('./resource');

Object.defineProperty(exports, 'resource', {
  enumerable: true,
  get: function get() {
    return _resource.SuperAgentResource;
  }
});


/*****************
 ** WEBPACK FOOTER
 ** ./~/tg-resources/dist/superagent/index.js
 ** module id = 1054
 ** module chunks = 1
 **/